import { useRef } from 'react'

import { motion, useMotionTemplate, useScroll, useTransform } from 'framer-motion'
import { ReactLenis } from 'lenis/dist/lenis-react'

// Team members data
const teamMembers = [
  {
    src: '/assets/member/teamate1.png',
    name: 'Christian Lee Richardson',
    content: 'Co-founder',
    start: -200,
    end: 200,
    className: 'w-1/3 max-md:w-[335px] max-md:h-[420px]'
  },
  {
    src: '/assets/member/teamate5.png',
    name: 'Wendell Thompson',
    content: 'Senior Full stack AI developer',
    start: -100,
    end: -250,
    className: 'w-1/3 max-md:w-[335px] max-md:h-[420px]'
  },
  {
    src: '/assets/member/teamate7.png',
    name: 'Matthew Dennis',
    content: 'Full Stack Developer',
    start: 0,
    end: 500,
    className: 'ml-auto w-1/3 max-md:w-[335px] max-md:h-[420px]'
  },
  {
    src: '/assets/member/teamate8.png',
    name: 'Irvan Wibowo',
    content: 'UI/UX Designer',
    start: -500,
    end: -500,
    className: 'w-1/3 max-md:w-[335px] max-md:h-[420px]'
  },
  // {
  //   src: '/assets/member/teamate2.png',
  //   name: 'Jesse Rohner',
  //   content: 'Co-founder, Full Stack & Blockchain Team Lead',
  //   start: 200,
  //   end: -250,
  //   className: 'mx-auto w-2/3 max-md:w-[335px] max-md:h-[420px]'
  // },
  // {
  //   src: '/assets/member/teamate4.png',
  //   name: 'William Andrew Franck',
  //   content: 'Senior Full Stack Developer',
  //   start: 0,
  //   end: -500,
  //   className: 'ml-24 w-5/12 max-md:w-[335px] max-md:h-[420px]'
  // },
  // {
  //   src: '/assets/member/teamate3.png',
  //   name: 'Vladislav Plazinskiy',
  //   content: 'Technical Team Lead',
  //   start: 200,
  //   end: -500,
  //   className: 'mx-auto w-2/3 max-md:w-[335px] max-md:h-[420px]'
  // },
  // {
  //   src: '/assets/member/teamate6.png',
  //   name: 'Dylan Matthess',
  //   content: 'Full Stack Developer',
  //   start: -300,
  //   end: -500,
  //   className: 'w-1/3 max-md:w-[335px] max-md:h-[420px]'
  // },
]

const ParallaxImages = () => {
  return (
    <div className='mx-auto max-w-5xl px-4 pt-[200px]'>
      {teamMembers.map((member, index) => (
        <ParallaxImg
          key={index}
          src={member.src}
          alt={member.name}
          name={member.name}
          content={member.content}
          start={member.start}
          end={member.end}
          className={member.className}
        />
      ))}
    </div>
  )
}

const ParallaxImg = ({
  className,
  alt,
  src,
  start,
  end,
  name,
  content
}: {
  className?: string
  alt: string
  src: string
  start: number
  end: number
  name: string
  content: string
}) => {
  const ref = useRef(null)

  const { scrollYProgress } = useScroll({
    target: ref,
    // @ts-ignore
    offset: [`${start}px end`, `end ${end * -1}px`]
  })

  const opacity = useTransform(scrollYProgress, [0.75, 1], [1, 0])
  const scale = useTransform(scrollYProgress, [0.75, 1], [1, 0.85])

  const y = useTransform(scrollYProgress, [0, 1], [start, end])
  const transform = useMotionTemplate`translateY(${y}px) scale(${scale})`

  return (
    <motion.div
      className={`relative team-member-img-on rounded-xl cursor-pointer ${className}`}
      ref={ref}
      style={{ transform, opacity }}
    >
      <figure>
        <motion.img src={src} alt={alt} className='w-full h-auto rounded-xl' />
      </figure>
      <div className='absolute bottom-0 left-0 right-0 lg:p-4 md:p-2 text-white bg-black bg-opacity-50'>
        <h2 className='text-14 font-bold font-archivo'>{name}</h2>
        <p className='text-[12px] font-archivo'>{content}</p>
      </div>
    </motion.div>
  )
}

export const SmoothScrollHero = () => {
  return (
    <div className='bg-zinc-950'>
      <ReactLenis
        root
        options={{
          lerp: 0.05
        }}
      >
        <Hero />
      </ReactLenis>
    </div>
  )
}

const Hero = () => {
  return (
    <div style={{ height: `calc(1000px + 100vh)` }} className='relative w-full'>
      <ParallaxImages />
      <div className='absolute bottom-0 left-0 right-0 h-96 bg-gradient-to-b from-zinc-950/0 to-zinc-950' />
    </div>
  )
}

export default Hero
